module.exports = __webpack_public_path__ + "static/media/GRC.abe1f4ec.jpg";